'use client';

import React, { FC, JSX, ReactElement } from 'react';
import {
  DefaultPageProps as BasicAreaPageLayoutProps,
  MagnoliaDamNode,
  MagnoliaNode
} from '@/types/cms/magnolia';
import ContactBar from '@/components/contactBar/ContactBar';
import { THEMES } from '@/Util/globals';
import { PageComponentProps } from '@/components/magnoliaPage/componentHelper';
import { HeroProps } from '@/components/hero/Hero';
import { ApiVideo } from '../../../api/model';
import CheckoutPageInner from '@/templates/checkout/CheckoutPageInner';
import CheckoutHeader from '@/templates/checkout/CheckoutHeader';
import classNames from 'classnames';
import { BackendData } from '@/templates/checkout/getBackendData';
import CheckoutStore from '@/templates/checkout/CheckoutStore';
import { useCheckoutContext } from '@/templates/checkout/CheckoutContextProvider';

export type CheckoutParams = {
  packageId: string;
  displayUrl: string;
  productCode: string;
  cacheDataProductCode: string;
  variantParam: string;
};

export interface CheckoutProps extends BasicAreaPageLayoutProps, PageComponentProps {
  themeContactInformation: string;
  showContactBar: boolean;
  heroBackgroundvideo: ApiVideo;
  heroBackgroundimage: MagnoliaDamNode;
  content: HeroProps['content'];
  privacyPolicyUrl: MagnoliaNode;
  regulationsUrl: MagnoliaNode;
  tAndCInsuranceUrl: string;
  allianzInsurancePdfUrl: string;
  adobeReaderUrl: string;
  useParticipantsMock: boolean;
  checkoutStore: CheckoutStore;
  backendData: BackendData;
  HeroComponent: ReactElement;
}

const CheckoutPageClient: FC<CheckoutProps> = (props): JSX.Element => {
  const {
    themeContactInformation,
    showContactBar,
    privacyPolicyUrl,
    regulationsUrl,
    adobeReaderUrl,
    tAndCInsuranceUrl,
    allianzInsurancePdfUrl,
    header,
    pageProps,
    useParticipantsMock,
    checkoutStore,
    backendData,
    HeroComponent
  } = props;
  const { setPacificProduct } = useCheckoutContext();
  const { siteConfig, rootNodePath } = pageProps || {};
  const { variantParam, confirmationPageMode } = backendData || {};

  return (
    <>
      <div className={classNames('page__top', { 'page__top--regular': confirmationPageMode })}>
        <CheckoutHeader header={header} />
        {showContactBar && <ContactBar theme={themeContactInformation || THEMES.darkGreen} />}
      </div>
      <div className="page__center">
        {HeroComponent}
        {backendData && (
          <CheckoutPageInner
            pageProps={pageProps}
            checkoutStore={checkoutStore}
            backendData={backendData}
            setPacificProduct={setPacificProduct}
            showContactBar={showContactBar}
            siteConfig={siteConfig}
            rootNodePath={rootNodePath}
            externalLinks={{
              privacyPolicyUrl,
              regulationsUrl,
              adobeReaderUrl,
              tAndCInsuranceUrl,
              allianzInsurancePdfUrl
            }}
            useParticipantsMock={useParticipantsMock}
            variantParam={variantParam}
          />
        )}
      </div>
    </>
  );
};

export default CheckoutPageClient;
